<template>
  <v-container fluid class="UploadPresentations">

    <div class="d-flex align-center pb-3">
      <div>
        <div class="display-1">
          Content Library
        </div>

        <presentation-breadcrumbs :items="[{text: 'Upload Files'}]">
        </presentation-breadcrumbs>

      </div>
      <!--<v-spacer></v-spacer>
      <v-btn color="primary">
        Add Content
      </v-btn>-->
    </div>

    <v-form @submit.prevent=""
            ref="form"
            v-if="files.length === 0"
            :disabled="form.busy">

      <v-stepper v-model="step"
                 class="mb-8 Stepper"
                 vertical>

        <v-stepper-step :complete="step > 1"
                        :editable="step > 1"
                        edit-icon="fas fa-check"
                        :step="1">
          Access Control
        </v-stepper-step>

        <v-stepper-content :step="1">
          <v-card flat
                  tile>
            <!--<v-card-title class="py-1">
              Access Control
            </v-card-title>-->
            <v-card-text class="pt-0">
              <presentation-form-owner :form="form">
              </presentation-form-owner>

              <presentation-form-groups :form="form">
              </presentation-form-groups>

            </v-card-text>
            <v-card-actions class="pt-0">
              <v-btn color="primary"
                     @click.prevent="step = 2">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-step :complete="step > 2"
                        :editable="step > 2"
                        edit-icon="fas fa-check"
                        :step="2">
          Sharing
        </v-stepper-step>

        <v-stepper-content :step="2">
          <v-card flat
                  tile
                  v-if="team.sharing_enabled">
            <v-card-text class="pt-0">

              <presentation-form-permissions :form="form"
                                             class="mb-4">
              </presentation-form-permissions>

              <presentation-form-share-template :form="form">
              </presentation-form-share-template>

              <presentation-form-share-theme :form="form">
              </presentation-form-share-theme>

              <presentation-form-analytics :form="form">
              </presentation-form-analytics>

            </v-card-text>
            <v-card-actions class="pt-0">
              <v-btn color="primary"
                     @click.prevent="step = 3">
                Continue
              </v-btn>
              <v-btn @click.prevent="step = 1">
                Back
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-step :complete="step > 3"
                        :editable="step > 3"
                        edit-icon="fas fa-check"
                        :step="3">
          Other Settings
        </v-stepper-step>

        <v-stepper-content :step="3">
          <template>
            <v-card flat
                    tile>
              <!--<v-card-title class="py-1">
                Additional Settings
              </v-card-title>-->
              <v-card-text class="pt-0">

                <presentation-form-folders :form="form">
                </presentation-form-folders>

                <presentation-form-labels :form="form">
                </presentation-form-labels>

                <presentation-form-publishing :form="form">
                </presentation-form-publishing>

                <presentation-form-language :form="form">
                </presentation-form-language>
              </v-card-text>
              <v-card-actions class="pt-0">
                <v-btn color="primary"
                       @click.prevent="step = 4">
                  Continue
                </v-btn>
                <v-btn @click.prevent="step = 2">
                  Back
                </v-btn>
              </v-card-actions>
            </v-card>

          </template>
        </v-stepper-content>

        <v-stepper-step :complete="step > 4"
                        :step="4">
          Upload
        </v-stepper-step>

        <v-stepper-content :step="4">

          <v-card flat
                  tile>
            <v-card-text>
              <v-btn block
                     :disabled="form.busy"
                     color="secondary"
                     @click.prevent="openFileStack()">
                Select Files
              </v-btn>
              <div id="filePicker"></div>
            </v-card-text>

            <v-card-actions class="pt-0">
              <v-btn @click.prevent="step = 3">
                Back
              </v-btn>
            </v-card-actions>

          </v-card>

        </v-stepper-content>

      </v-stepper>

    </v-form>

    <v-card v-if="files.length">
      <v-progress-linear v-if="progress"
                         :value="progress.totalPercent"
                         :height="32"
                         :color="progress.totalPercent === 100 ? 'success' : 'primary'">
      </v-progress-linear>
      <v-list v-if="files.length">
        <v-list-item v-for="(file, n) in files"
                     :key="n"
                     class="mb-2">
          <v-list-item-content>
            <v-list-item-title>
              {{ file.filename }}
            </v-list-item-title>
            <v-progress-linear v-if="files.length > 1"
                               :value="file.totalPercent"
                               :color="file.totalPercent === 100 ? 'success' : 'primary'">
            </v-progress-linear>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon v-if="file.error"
                    color="error">
              fal fa-exclamation-triangle
            </v-icon>
            <template v-else-if="file.totalPercent < 100">
              {{ file.totalPercent }}%
            </template>
            <v-icon color="success"
                    v-else>
              fal fa-check-circle
            </v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-text v-if="presentationJobs.length">
        <pre>{{ jobs }}</pre>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary"
               @click.prevent="initForm(1)">
          Upload More Files
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import presentationService from '../../../../ml/services/presentationService';
import formValidation from '../../plugins/formValidation';
import filestackService from '../../../../ml/services/filestackService';
import PresentationFormLanguage from './components/PresentationFormLanguage';
import PresentationFormOwner from "./components/PresentationFormOwner";
import PresentationFormFolders from './components/PresentationFormFolders';
import PresentationFormGroups from './components/PresentationFormGroups';
import PresentationFormLabels from './components/PresentationFormLabels';
import PresentationFormPublishing from './components/PresentationFormPublishing';
import PresentationFormPermissions from './components/PresentationFormPermissions';
import PresentationFormShareTheme from './components/PresentationFormShareTheme';
import PresentationFormShareTemplate from './components/PresentationFormShareTemplate';
import PresentationFormAnalytics from './components/PresentationFormAnalytics';
import {clone, findIndex, merge, uniqBy} from 'lodash';
import axios from "axios";
import pluralize from 'pluralize';

export default {
  components: {
    PresentationFormAnalytics,
    PresentationFormFolders,
    PresentationFormGroups,
    PresentationFormLabels,
    PresentationFormLanguage,
    PresentationFormOwner,
    PresentationFormPermissions,
    PresentationFormPublishing,
    PresentationFormShareTemplate,
    PresentationFormShareTheme,
  },
  mixins: [formValidation],
  data() {
    return {
      client: filestackService.client,
      errors: [],
      files: [],
      form: new Form(presentationService.presentationFormFields()),
      progress: null,
      step: 1,
      status: null,
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'presentationJobs',
      'team',
      'user',
    ]),
    jobs() {
      return uniqBy(this.presentationJobs, 'presentation_id');
    },
    accept() {
      return [
        'application/epub+zip',
        'application/msword',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/zip',
        // MLD-3326 - alternative mime types so it will work on Windows
        'application/x-zip',
        'application/zip-compressed',
        'application/x-zip-compressed',
        'image/gif',
        'image/png',
        'image/jpeg',
        'video/mpeg',
        'application/vnd.oasis.opendocument.presentation',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.text',
      ];
    },
    isUploading() {
      return this.status === 'Uploading';
    },
    isDone() {
      return this.status === 'Done';
    }
  },
  created() {
    this.initForm(1);
  },
  methods: {
    initForm(step) {
      this.errors = [];
      this.files = [];
      this.progress = null;
      this.status = null;
      this.step = step;

      this.form.reset();
      presentationService.configureDefaults(this.team, this.form);
      if (!this.isAdmin) {
        this.form.userPresentation = 1;
      }
    },
    fetchData() {
      this.$store.dispatch('fetchFolders');
      this.$store.dispatch('fetchGroups');
      this.$store.dispatch('fetchLabels');
      this.$store.dispatch('fetchUsers');
    },
    isFormValid() {
      /*if (this.form.files.length === 0) {
        return false;
      }*/
      return this.$refs.form.validate();
    },
    openFileStack() {
      const options = {
        accept: this.accept,
        minFiles: 1,
        maxFiles: 100,
        maxSize: 1024 * 1024 * 1024, // 1 GB
        hideModalWhenUploading: true,
        uploadInBackground: false,
        disableThumbnails: true,
        disableTransformer: true,
        onCancel: () => {
          //console.log('onCancel', arguments);
        },
        onClose: () => {
          //console.log('onClose', arguments);
        },
        onFileSelected: this.fileSelected,
        onFileUploadFailed: this.fileUploadFailed,
        onFileUploadFinished: this.fileUploadFinished,
        onFileUploadProgress: this.fileUploadProgress,
        onFileUploadStarted: this.fileUploadStarted,
        onOpen: () => {
          console.log('onOpen', arguments);
        },
        onUploadDone: this.uploadDone,
        onUploadStarted: this.uploadStarted,
      }
      filestackService.showPicker(options);
    },
    fileSelected(file) {
      //console.log('File selected', file);
    },
    fileUploadStarted(file) {
      //console.log('fileUploadStarted', file.filename);
      this.updateFile(file, 'Uploading');
    },
    updateFile(file, status) {
      //console.log('updateFile', file.filename, status);
      file.status = status;
      const index = findIndex(this.files, f => {
        return (f.uploadId === file.uploadId);
      });
      if (index > -1) {
        //this.files[index] = file;
        merge(this.files[index], file);
        //console.log('updated', this.files[index]);
      } else {
        this.files.push(file);
      }
    },
    fileUploadProgress(file, progressEvent) {
      //console.log('fileUploadProgress', file.filename, progressEvent.totalPercent);
      this.progress = progressEvent;
      file.totalPercent = progressEvent.totalPercent;
      this.updateFile(file, 'Uploading');
    },
    fileUploadFinished(file) {
      const data = {
        file: file,
        owner_id: this.form.owner_id,
        groups: this.form.groups.map(g => g),
        labels: this.form.labels.map(l => l),
        folders: this.form.folder_ids.map(f => f),
        locale: this.form.locale,

        release_at: this.form.release_at,
        expires_at: this.form.expires_at,
        reviewer_id: this.form.reviewer_id,

        can_be_annotated: this.form.settings.can_be_annotated,
        can_be_downloaded: this.form.settings.can_be_downloaded,
        can_be_exported: this.form.settings.can_be_exported,
        can_be_forwarded: this.form.settings.can_be_forwarded, // MLD-1421
        can_be_printed: this.form.settings.can_be_printed,
        can_be_shared: this.form.settings.can_be_shared,
        can_be_shared_link: this.form.settings.can_be_shared_link, // MLD-1641
        is_rateable: this.form.is_rateable,

        share_template_id: this.form.share_template_id,
        share_theme_id: this.form.share_theme_id, // MLD-967

        facebook_pixel: this.form.facebook_pixel,
        google_analytics_id: this.form.google_analytics_id,
        hubspot_pixel: this.form.hubspot_pixel,
        linkedin_pixel: this.form.linkedin_pixel,
      };
      console.log('fileUploadFinished', data);
      axios.post(`/api/import/filestack`, data)
        .then(() => {
          file.success = true;
          this.updateFile(file, 'Uploaded');
          return null;
        })
        .catch(err => {
          if (err.response) {
            this.errors.push({
              file: file,
              error: err.response.data,
            });
          }
          file.error = err.response.data;
          this.updateFile(file, 'Error');
        })
        .finally(() => {
          this.$store.dispatch('fetchPresentationJobs')
            .catch(() => {
            });
        })
    },
    fileUploadFailed(file, error) {
      //console.log('File upload failed', file.filename, error);
      file.error = error;
      this.errors.push(error);
      this.updateFile(file, 'Failed');
      this.errors.push(error);
      this.form.setErrors({global: error});
    },
    uploadStarted(fsFiles) {
      this.status = 'Uploading';
      this.form.startProcessing();
      console.log('uploadStarted', fsFiles);
      const files = clone(fsFiles);
      files.forEach(f => {
        f.status = 'Queued';
        f.totalPercent = 0;
      })
      this.files = files;
    },
    uploadDone({filesUploaded, filesFailed}) {
      this.status = 'Done';
      this.form.busy = false;
      console.log('uploadDone', filesUploaded, filesFailed);
      this.$store.dispatch('fetchPresentationJobs')
        .catch(() => {
        });
      if (filesFailed.length === 0) {
        this.$toast.success(`Processing ${pluralize('file', filesUploaded.length, true)}`);
        this.$router.push({name: 'presentations', query: {sortBy: 'created_at', sortDesc: 1}})
      }
    }
  }
}
</script>
